import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconPlusCircle: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className={className}
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_388_1330)">
                        <path
                            d="M8 13C11.0948 13 13.6667 10.4281 13.6667 7.33333C13.6667 4.23858 11.0948 1.66667 8 1.66667C4.90524 1.66667 2.33333 4.23858 2.33333 7.33333C2.33333 10.4281 4.90524 13 8 13Z"
                            stroke="currentColor"
                            strokeWidth="0.77778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6 7.33333H10"
                            stroke="currentColor"
                            strokeWidth="0.77778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8 5.33333V9.33333"
                            stroke="currentColor"
                            strokeWidth="0.77778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_388_1330">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className={className}
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_388_1335)">
                        <path
                            d="M10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25Z"
                            stroke="currentColor"
                            strokeWidth="0.97222"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M7.5 10H12.5"
                            stroke="currentColor"
                            strokeWidth="0.97222"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M10 7.5V12.5"
                            stroke="currentColor"
                            strokeWidth="0.97222"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_388_1335">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className={className}
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_387_1300)">
                        <path
                            d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z"
                            stroke="currentColor"
                            strokeWidth="1.16667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9 12H15"
                            stroke="currentColor"
                            strokeWidth="1.16667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12 9V15"
                            stroke="currentColor"
                            strokeWidth="1.16667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_387_1300">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
